var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.309,
    height: 15.047,
    viewBox: "0 0 18.309 15.047",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-share",
    "data-name": "Icon feather-share",
    transform: "translate(-2 20.047) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_26",
    "data-name": "Union 26",
    d: "M-4786.951-1104a2.634,2.634,0,0,1-2.631-2.631v-6.523a1,1,0,0,1,1-1,1,1,0,0,1,1,1v6.523a.632.632,0,0,0,.631.631h9.785a.631.631,0,0,0,.631-.631v-6.523a1,1,0,0,1,1-1,1,1,0,0,1,1,1v6.523a2.634,2.634,0,0,1-2.631,2.631Zm3.892-6.708v-8.186l-1.554,1.554a1,1,0,0,1-1.415,0,1,1,0,0,1,0-1.414l3.25-3.25a1,1,0,0,1,.669-.3h.1a1,1,0,0,1,.679.314l3.24,3.24a1,1,0,0,1,0,1.414.994.994,0,0,1-.707.293.993.993,0,0,1-.707-.293l-1.555-1.555v8.186a1,1,0,0,1-1,1A1,1,0,0,1-4783.059-1110.71Z",
    transform: "translate(4794.582 1124.31)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logoutIcon.1a4b0367781ec354a1c0177a7cd8c172.svg";
export { ForwardRef as ReactComponent };